import { forwardRef } from 'react';

import { IconProps } from '@sternum/web/icons/icons.types';

export const Cube3DIcon = forwardRef<SVGSVGElement, IconProps>(function Cube3DIcon(
  { color, height = 12, width = 12, ...props },
  ref,
) {
  return (
    <svg
      ref={ref}
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.767744 4.86782C0.962986 4.54236 1.39476 4.43121 1.73213 4.61955L8.99549 8.67451L16.2072 4.64466C16.5445 4.45618 16.9763 4.56716 17.1717 4.89255C17.3671 5.21794 17.252 5.63451 16.9147 5.82299L9.34942 10.0504C9.1307 10.1726 8.86092 10.1727 8.64214 10.0506L1.0251 5.79816C0.687723 5.60981 0.572501 5.19328 0.767744 4.86782Z"
        fill={color || 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.99567 8.77215C9.38547 8.77215 9.70146 9.07699 9.70146 9.45302V17.0008C9.70146 17.3769 9.38547 17.6817 8.99567 17.6817C8.60588 17.6817 8.28988 17.3769 8.28988 17.0008V9.45302C8.28988 9.07699 8.60588 8.77215 8.99567 8.77215Z"
        fill={color || 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.99559 7.05709e-06C9.73039 -0.00117239 10.5038 0.145441 11.1291 0.475901L11.133 0.477995L15.7383 2.94894C16.3964 3.30067 16.9541 3.89015 17.3447 4.5292C17.7354 5.16843 18 5.92365 18 6.64859V11.3504C18 12.0753 17.7354 12.8305 17.3447 13.4698C16.9541 14.1088 16.3971 14.6979 15.739 15.0497L11.1313 17.5219C10.5087 17.8538 9.7342 18 9 18C8.26579 18 7.49129 17.8538 6.86866 17.5219L2.26169 15.05C1.60358 14.6983 1.04593 14.1089 0.655298 13.4698C0.264577 12.8305 0 12.0753 0 11.3504V6.64859C0 5.92365 0.264577 5.16843 0.655298 4.5292C1.046 3.88999 1.60315 3.30079 2.26141 2.94909L6.8663 0.486694C7.48916 0.149876 8.26186 0.00118477 8.99559 7.05709e-06ZM8.99794 1.36174C8.43626 1.36264 7.91578 1.47997 7.55555 1.67506L7.55222 1.67687L2.94575 4.14009C2.56035 4.34596 2.16843 4.73464 1.87124 5.22086C1.57401 5.70713 1.41158 6.22514 1.41158 6.64859V11.3504C1.41158 11.7738 1.57401 12.2918 1.87123 12.7781C2.16843 13.2643 2.56007 13.6529 2.94548 13.8587L2.94664 13.8593L7.55142 16.33L7.55241 16.3305C7.91315 16.5225 8.43646 16.6383 9 16.6383C9.56354 16.6383 10.0869 16.5225 10.4476 16.3305L10.4486 16.33L15.0534 13.8593L15.0545 13.8587C15.4399 13.6529 15.8316 13.2643 16.1288 12.7781C16.426 12.2918 16.5884 11.7738 16.5884 11.3504V6.64859C16.5884 6.22514 16.426 5.70713 16.1288 5.22086C15.8316 4.73464 15.4399 4.34611 15.0545 4.14024L15.0534 4.13962L10.4491 1.66922C10.0824 1.47599 9.55832 1.36084 8.99794 1.36174Z"
        fill={color || 'currentColor'}
      />
    </svg>
  );
});
